// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportsConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';
import { VALID_REPORT_NAME_REGEX } from 'logic/data/Izenda.ReportDesignerConstants';
import { forEach, isEmpty } from 'lodash/fp';
function buildListFilter(filters) {
  if (isEmpty(filters)) {
    return '';
  }

  let result = '<ul style="list-style-type: decimal" >';

  forEach(filter => {
    const filterString = `<li>${filter.alias}</li>`;
    result += filterString;
  }, filters);

  result += '</ ul>';

  return result;
}

const LEFT_MENU_CONCAT_TREE_MAP = [
  {
    prop: 'subCategories',
    expand: false,
    children: [
      {
        prop: 'subCategories',
        expand: false
      }
    ]
  }
];

export default {
  NO_PERMISSION: 'NO_PERMISSION',
  CATEGORY_TYPE: {
    REPORT: '0',
    TEMPLATES: '1',
    CATEGORY_ID: 'CategoryId',
    SUB_CATEGORY_ID: 'SubCategoryId'
  },
  reportTypeName(reportType) {
    return reportType === '0' ? 'report' : 'template';
  },
  REPORT_PROPERTY: {
    All: 0,
    DataSource: 1,
    Relationship: 2,
    Filter: 3,
    ReportPart: 4,
    CalculatedField: 5,
    DynamicQuerySourceField: 6,
    Scheduling: 7,
    Access: 8,
    Report: 9
  },
  ALL_CATEGORY_TYPES: {
    ALL_REPORTS: {
      get name() {
        return localizer.getText('REPORTS_CONSTANTS_LABEL_ALL_REPORTS');
      },
      type: 0,
      id: '0000',
      isGlobal: null
    },
    ALL_TEMPLATES: {
      get name() {
        return localizer.getText('REPORTS_CONSTANTS_LABEL_ALL_TEMPLATES');
      },
      type: 1,
      id: '0000',
      isGlobal: null
    }
  },
  ACTION_TYPES: {
    get MOVE_TITLE() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_LABEL_MOVE');
    },
    MOVE_CONTENT: ' move ',
    get COPY_TITTLE() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_LABEL_COPY');
    },
    COPY_CONTENT: ' copy '
  },

  SEARCH_CRITERIA: [
    {
      value: 'All',
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    {
      value: 'ReportName',
      get label() {
        return localizer.getText('COMMON_LABEL_REPORT_NAME');
      }
    },
    {
      value: 'ReportDescription',
      get label() {
        return localizer.getText('COMMON_LABEL_REPORT_DESCRIPTION');
      }
    },
    {
      value: 'CreatedBy',
      get label() {
        return localizer.getText('COMMON_CRITERIA_CREATED_BY');
      }
    },
    {
      value: 'CreatedDate',
      get label() {
        return localizer.getText('COMMON_CRITERIA_CREATED_DATE');
      }
    },
    {
      value: 'LastEditedBy',
      get label() {
        return localizer.getText('COMMON_CRITERIA_EDITED_BY');
      }
    },
    {
      value: 'LastEditedDate',
      get label() {
        return localizer.getText('COMMON_CRITERIA_EDITED_DATE');
      }
    },
    {
      value: 'Category',
      get label() {
        return localizer.getText('COMMON_LABEL_CATEGORY');
      }
    },
    {
      value: 'Subcategory',
      get label() {
        return localizer.getText('COMMON_LABEL_SUBCATEGORY');
      }
    }
  ],
  TEMPLATE_SEARCH_CRITERIA: [
    {
      value: 'All',
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    {
      value: 'ReportName',
      get label() {
        return localizer.getText('COMMON_LABEL_TEMPLATE_NAME');
      }
    },
    {
      value: 'ReportDescription',
      get label() {
        return localizer.getText('COMMON_LABEL_TEMPLATE_DESCRIPTION');
      }
    },
    {
      value: 'CreatedBy',
      get label() {
        return localizer.getText('COMMON_CRITERIA_CREATED_BY');
      }
    },
    {
      value: 'CreatedDate',
      get label() {
        return localizer.getText('COMMON_CRITERIA_CREATED_DATE');
      }
    },
    {
      value: 'LastEditedBy',
      get label() {
        return localizer.getText('COMMON_CRITERIA_EDITED_BY');
      }
    },
    {
      value: 'LastEditedDate',
      get label() {
        return localizer.getText('COMMON_CRITERIA_EDITED_DATE');
      }
    },
    {
      value: 'Category',
      get label() {
        return localizer.getText('COMMON_LABEL_CATEGORY');
      }
    },
    {
      value: 'Subcategory',
      get label() {
        return localizer.getText('COMMON_LABEL_SUBCATEGORY');
      }
    }
  ],
  SORT_CRITERIA: [
    {
      value: 'ReportName',
      get label() {
        return localizer.getText('COMMON_LABEL_REPORT_NAME');
      }
    },
    {
      value: 'CreatedBy',
      get label() {
        return localizer.getText('COMMON_CRITERIA_CREATED_BY');
      }
    },
    {
      value: 'CreatedDate',
      get label() {
        return localizer.getText('COMMON_CRITERIA_CREATED_DATE');
      }
    },
    {
      value: 'LastEditedBy',
      get label() {
        return localizer.getText('COMMON_CRITERIA_EDITED_BY');
      }
    },
    {
      value: 'LastEditedDate',
      get label() {
        return localizer.getText('COMMON_CRITERIA_EDITED_DATE');
      }
    },
    {
      value: 'NumberOfView',
      get label() {
        return localizer.getText('COMMON_CRITERIA_NUMBER_OF_VIEWS');
      }
    },
    {
      value: 'RenderingTime',
      get label() {
        return localizer.getText('COMMON_CRITERIA_AVERAGE_RENDERING_TIME');
      }
    },
    {
      value: 'Category',
      get label() {
        return localizer.getText('COMMON_LABEL_CATEGORY');
      }
    },
    {
      value: 'Subcategory',
      get label() {
        return localizer.getText('COMMON_LABEL_SUBCATEGORY');
      }
    },
    {
      value: 'LastViewed',
      get label() {
        return localizer.getText('COMMON_CRITERIA_LAST_VIEWED');
      }
    }
  ],
  TEMPLATE_SORT_CRITERIA: [
    {
      value: 'ReportName',
      get label() {
        return localizer.getText('COMMON_LABEL_TEMPLATE_NAME');
      }
    },
    {
      value: 'CreatedBy',
      get label() {
        return localizer.getText('COMMON_CRITERIA_CREATED_BY');
      }
    },
    {
      value: 'CreatedDate',
      get label() {
        return localizer.getText('COMMON_CRITERIA_CREATED_DATE');
      }
    },
    {
      value: 'LastEditedBy',
      get label() {
        return localizer.getText('COMMON_CRITERIA_EDITED_BY');
      }
    },
    {
      value: 'LastEditedDate',
      get label() {
        return localizer.getText('COMMON_CRITERIA_EDITED_DATE');
      }
    },
    {
      value: 'NumberOfView',
      get label() {
        return localizer.getText('COMMON_CRITERIA_NUMBER_OF_VIEWS');
      }
    },
    {
      value: 'RenderingTime',
      get label() {
        return localizer.getText('COMMON_CRITERIA_AVERAGE_RENDERING_TIME');
      }
    },
    {
      value: 'Category',
      get label() {
        return localizer.getText('COMMON_LABEL_CATEGORY');
      }
    },
    {
      value: 'Subcategory',
      get label() {
        return localizer.getText('COMMON_LABEL_SUBCATEGORY');
      }
    },
    {
      value: 'LastViewed',
      get label() {
        return localizer.getText('COMMON_CRITERIA_LAST_VIEWED');
      }
    }
  ],
  SORT_TYPES: {
    ASC: 'asc',
    DESC: 'desc'
  },
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
  UNCATEGORIZED: 'Uncategorized',
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
  CONSTRAINTS: {
    NAME: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('REPORTDESIGNER_MESSAGE_REPORT_NAME_REQUIRED');
        }
      },
      format: {
        pattern: VALID_REPORT_NAME_REGEX,
        get message() {
          return localizer.getText('INVALID_REPORT_NAME');
        }
      }
    },
    TEMPLATE_NAME: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('REPORTDESIGNER_MESSAGE_TEMPLATE_NAME_REQUIRED');
        }
      },
      format: {
        pattern: VALID_REPORT_NAME_REGEX,
        get message() {
          return localizer.getText('INVALID_TEMPLATE_NAME');
        }
      }
    }
  },
  MESSAGES: {
    get M03() {
      return localizer.getText('CATEGORY_MESSAGES_CONFIRM_DELETE_CATEGORY');
    },
    get M04() {
      return localizer.getText('CATEGORY_MESSAGES_CONFIRM_DELETE_SUBCATEGORY');
    },
    get M05a() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_DELETE_REPORT');
    },
    get M05b() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_DELETE_TEMPLATE');
    },
    get M06a() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SUCCESSFULLY_COPIED');
    },
    get M06b() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SUCCESSFULLY_MOVED');
    },
    get SAVE_REPORT() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SAVE_REPORT');
    },
    get SAVE_AS_REPORT() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SAVE_AS_REPORT');
    },
    get INVALID_REPORT() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_INVALID_REPORT');
    },
    get CANCEL() {
      return localizer.getText('COMMON_MESSAGES_CONFIRM_CHANGES_LOST');
    },
    UPDATE_RESULT(filterFields) {
      let result = `<p> ${localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_DIFFERENT_SCHEMA')} </p>`;
      return (result += buildListFilter(filterFields));
    },
    EMPTY_FILTER_PARAM(filterFields) {
      let result = `<p> ${localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_FILTER_VALUE')}</p>`;
      return (result += buildListFilter(filterFields));
    },
    EMPTY_REQUIRED_FILTER(filterFields) {
      let result = `<p> ${localizer.getText(
        'REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_REQUIRE_AND_NOT_VISIBLE_FIELD'
      )}</p>`;
      return (result += buildListFilter(filterFields));
    },
    EMPTY_VISIBLE_REQUIRED_FILTER(filterFields) {
      let result = `<p> ${localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_REQUIRE_AND_VISIBLE_FIELD')}</p>`;
      return (result += buildListFilter(filterFields));
    },
    EMPTY_REQUIRED_PARAM_FILTER(paramFilters, requiredFilters) {
      let result = '';

      let paramsMessage = `<div> <p>- ${localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_FILTER_VALUE')}</p>`;
      paramsMessage += `${buildListFilter(paramFilters)}</div>`;
      result += paramsMessage;

      let requiedMessage = `<div> <p>- ${localizer.getText(
        'REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_REQUIRE_AND_NOT_VISIBLE_FIELD'
      )}</p>`;
      requiedMessage += `${buildListFilter(requiredFilters)}</div>`;
      result += requiedMessage;

      return result;
    },
    get NEED_UPDATE_RESULTS() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_CLICK_UPDATE_RESULT');
    }
  },
  COPY_REPORT: {
    get TEXT_CREATE_CATEGORY() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_TEXT_CREATE_CATEGORY');
    },
    get TEXT_CREATE_SUB_CATEGORY() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_TEXT_CREATE_SUB_CATEGORY');
    }
  },
  FITLERS_PANEL_UI: {
    minHeight: 55,
    maxHeight: 210
  },
  SYSTEM_VARIABLES: {
    REPORT_NAME: '{reportName}',
    CURRENT_DATETIME: '{currentDateTime}',
    CURRENT_USERNAME: '{currentUserName}',
    TENANT_NAME: '{tenantName}'
  },
  MINIMUM_ROW: 4,
  DATETIME_FORMAT: 'MM/dd/yyyy',
  SUBREPORT_POPUP: {
    get popupTitle() {
      return localizer.getText('REPORTS_CONSTANTS_REPORT_LABEL_SUBREPORT');
    },
    frameHeightInPx: '700px',
    frameWidthInPercent: '100%'
  },
  REPORT_EXPORT_IFRAME_POPUP: {
    get popupTitle() {
      return localizer.getText('REPORTS_CONSTANTS_IFRAME_EXPORT_POPUP_LABEL');
    }
  },
  GRID_PREVIEW_POPUP_SIZE: {
    height: 500
  },
  REPORT_LIST_CONCAT_TREE_MAP: [
    {
      prop: 'subCategories',
      children: [
        {
          prop: 'subCategories',
          children: [
            {
              prop: 'reports'
            }
          ]
        }
      ]
    }
  ],
  LEFT_MENU_CONCAT_TREE_MAP,
  LEFT_MENU_TREE_MAP: [
    {
      prop: 'globalLocalCategory',
      expand: true,
      children: LEFT_MENU_CONCAT_TREE_MAP
    }
  ]
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ReportsConstants.js